"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("../colors");
var spacingTokens_1 = require("../spacingTokens");
var utilityTokens_1 = require("../utilityTokens");
var defaultTheme = {
    global: __assign(__assign({ '*': {
            fontFamily: 'Open Sans, sans-serif',
            boxSizing: 'border-box',
        } }, spacingTokens_1.GlobalSpacingTokens.cssSpacingObj), utilityTokens_1.GlobalUtilityTokens.cssUtilityObj),
    color: {
        ACCENT: colors_1.SixsenseColor.Teal,
        PRIMARY: colors_1.SixsenseColor.Blue,
        GRAY: colors_1.SixsenseColor.Gray,
        SUCCESS: colors_1.SixsenseColor.Green,
        WARNING: colors_1.SixsenseColor.Yellow,
        ERROR: colors_1.SixsenseColor.Red,
        BLACK: colors_1.SixsenseColor.Black,
        WHITE: colors_1.SixsenseColor.White,
    },
    border: "1px solid " + colors_1.SixsenseColor.Gray.LIGHT_3,
    content: {
        backgroundColor: colors_1.SixsenseColor.White.DEFAULT,
        color: colors_1.SixsenseColor.Gray.DARK_2,
    },
    // tokens to be consumed from emotion theme. css((theme: Theme) => { ...theme.token.p2}
    token: __assign(__assign({}, spacingTokens_1.GlobalSpacingTokens.emotionSpacingObj), utilityTokens_1.GlobalUtilityTokens.emotionUtilityObj),
    zIndex: {
        MODAL: 100,
    },
};
exports.default = defaultTheme;
